import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRelatedDPS = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: dps, total },
  } = await axios.get(`/api/companies/${companyID}/dps?${queryString}`);

  return { dps, total };
};

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  includeExpired: false,
  sortBy: 'dateCreated',
  queryKey: ['companies-related-dps'],
  queryOptions: {},
};

export const useGetRelatedDPS = (companyID, queryParams = {}) => {
  const { page, limit, search, includeInactive, includeExpired, sortBy, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    includexpired: includeExpired,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery(
    [...queryKey, companyID],
    () => getRelatedDPS(companyID, queryStringParams),
    {
      select: ({ dps, total }) => ({ dps, total }),
      initialData: { dps: [], total: 0 },
      ...queryOptions,
    }
  );
}